<!-- <div *ngIf="page === 'answer' && isLastDay && question['answers'] && questionNo < 3" class="question-finish-tips">已完成</div> -->
<!--标题-->
<div class="question-title-wrap {{page}}" *ngIf="tabNum != 1">
  <!-- 实战作业day14链接提示 -->
  <div class="tipText" *ngIf="isLastDay && campId!=2 && page==='answer' && question.type === 5">
    <img src="{{assetsRoute}}/picture/camp/blue_tip.png" alt="">
    <span>手机答题不便利？前往电脑端，完成作业吧！<br>链接：<a href="javascript:void(0);" (click)="copyUrl()">{{pcUrl}}</a></span>
  </div>
  <div class="question-title">
    <p>{{questionNo}}.<span [innerHTML]=" campId? intelligentTitleType[question.type - 1]: intelligentTitleType[question.type - 1] "></span></p>
    <span class="title-content" [innerHTML]="question['questionTitle']"></span>
    <span *ngIf="exerciseType === 3 && question.type === 4" class="question-type-tips">多选题</span>
  </div>
</div>

<!-- 作答完成展示页面 -->
<div class="question-show-wrap question-show-wrap-{{relationId}}" *ngIf="page === 'finish' || page === 'list' " >
<ng-container *ngIf="question['answers']!==null">
  <div *ngIf="question.type === 1 || question.type === 7"  class="question-show-item answer-{{relationId}}-{{questionNo}}">
    <p class="item-title" *ngIf="tabNum == 1 && (isLastDay || isFirstDay)" [innerHTML]="questionNo == 2? '2.你的具体挑战' : '3.你的计划' "></p>
    <pre >{{question['answers']}}</pre>
  </div>
  <div *ngIf="question.type === 2"  class="answer-{{relationId}}-{{questionNo}}">
    <p class="item-title" *ngIf="tabNum == 1" [innerHTML]="'1.你的管理问题'"></p>
    <span [innerHTML]="getRadioAnswer(question['answers'])"></span>
  </div>
  <!-- 步骤题 -->
  <div *ngIf="question.type === 3"  class="answer-{{relationId}}-{{questionNo}}" id="type-{{question.type}}">
    <div class="show-step-table" *ngFor="let item of stepGroup;let i=index">
      <div class="table-top"><p>策略 {{i+1}}</p><p [innerHtml] = "item[0]"></p></div>
      <div class="table-bottom"><p>话术</p><pre [innerHtml] = "item[1]"></pre>
      </div>
    </div>
  </div>
  <!-- 只有训练营才展示多选题，智能作业我的作答展示学员作答不展示 -->
  <div *ngIf="question.type === 4 && (campId || tabNum == 0)" class="answer-{{relationId}}-{{questionNo}}">
    <ng-container *ngIf="tabNum == 0 || campId">
      <div *ngFor="let item of question['options']; let i =index">
        <p *ngIf="item['select']">{{item['context']}}</p>
      </div>
    </ng-container>
    <ng-container *ngIf="tabNum == 1">
      <p class="item-title" *ngIf="campId" [innerHTML]="'1.你的管理问题'"></p>
      <div [innerHTML]="question['answers']"></div>
    </ng-container>
  </div>
</ng-container>

  <div *ngIf="question.type === 5 && isLastDay" id="type-{{question.type}}" class="answer-{{relationId}}-{{questionNo}}"  [ngClass]="{ 'height0' :  page === 'answer' }">
    <p class="item-title" *ngIf="tabNum == 1" [innerHTML]="'4.你的具体准备' "></p>
    <pre *ngIf="question['answers']" style="margin-bottom: .3rem;">{{question['answers']}}</pre>
    <div class="actural-question-upload-list" *ngIf="uploadList && uploadList.length > 0">
      <div class="upload-item" [ngStyle]="{'background': item['fileType'] === 1 ? 'url('+ item['fileUrl'] +') no-repeat' : 'white','background-size':item['fileType'] === 1 ? 'cover':'unset' }" *ngFor="let item of uploadList;let i=index"  (click)="showPreview(item['fileUrl'],item['fileType'])">
        <div class="item-file-name" *ngIf="item['fileType'] !== 1">
          <div *ngIf="!item.extend" class="file-icon"></div>
          <img *ngIf="item.extend" src="{{assetsRoute}}/picture/applicationTool/{{item.extend}}.png" class="tool-icon">
          <div class="file-name">{{item['fileName']}}</div>
        </div>
      </div>
    </div>
  </div>

<!-- 表格题 -->
  <div *ngIf="question.type === 6"  class="answer-{{relationId}}-{{questionNo}}" id="type-{{question.type}}">
    <div class="show-table" *ngFor="let item of stepGroup;let i=index">
      <div class="table-top"><p>{{question['tableTitleShow'][0]}}</p><p [innerHtml] = "item[0]"></p></div>
      <div class="table-bottom"><p>{{question['tableTitleShow'][1]}}</p><pre [innerHtml] = "item[1]"></pre>
      </div>
    </div>
  </div>
  <!-- 步骤题 -->
  <div *ngIf="question.type === 8"  class="answer-{{relationId}}-{{questionNo}}" id="type-{{question.type}}">
    <div class="show-step-table" *ngFor="let item of stepGroup;let i=index">
      <div class="table-top"><p>{{question['tableTitleShow'][0]}}</p><p [innerHtml] = "item[0]"></p></div>
      <div class="table-bottom"><p>{{question['tableTitleShow'][1]}}</p><pre [innerHtml] = "item[1]"></pre></div>
    </div>
  </div>
</div>

<!--答题展现-->
<div class="question-answer-wrap answer-{{questionNo}} {{page}}" [ngClass]=" page === 'answer'? 'active':'' " *ngIf="page==='answer'"  >
<!--  文本题-->
  <component-textarea *ngIf="question.type === 1 || (campId !=2 && isLastDay && checkElse && question.type === 5)" [id]="questionNo" [type]="1" [questionId]="question['questionId']" [textareaValue]="question['answers']?question['answers']:''" [isShowWordLimit]="isLastDay || exerciseType!==3" [maxLen]="isFirstDay || isLastDay ? 500 : exerciseType === 3 ? 9999 : 200" [placeholder]="isFirstDay || isLastDay && questionNo == 2? '描述你具体的挑战' : isLastDay && questionNo == 3? '说明你的计划': isLastDay && questionNo == 4?'写下你的具体准备':'请输入你的答案...'" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
<!--  单选题-->
  <ul class="question-answer-radio question-{{question['questionId']}}" *ngIf="question.type === 2">
    <li *ngFor="let item of question['options'];let i=index" [ngClass]="campId? (item.select?'active':'') : (singleCurrentId == item.optionId? (item.correct ? 'right':'wrong') : '') " (click)="optSelected(question['questionId'],i,item['optionId'],item['correct'],item['analysis'])">
      <span>{{item.context.split(".")[0]}}.</span><span>{{item.context.split(".")[1]}}</span>
    </li>
  </ul>

  <div *ngIf="question.type === 2 && isShowAnalysis && !isLastDay"  class="question-answer-analysis">
    <p><span>答案解析</span><span>（点击选项可以重新选择答案）</span></p>
    <span [innerHtml]="analysis" ></span>
  </div>

<!--  步骤题-->
  <div class="question-answer-step question-{{question['questionId']}}" id="type-{{question.type}}" *ngIf="question.type === 3">
    <div class="answer-step-wrap" id="answer-step-wrap-{{i}}" *ngFor="let item of stepGroup;let i=index">
      <div class="step-title">
        <span class="step-circle"></span>
        <p>步骤{{i+1}}</p>
        <div *ngIf="stepGroup.length > 1" class="minus-step" (click)="minusStep(i,question['questionId'])"></div>
      </div>
      <div class="step-content">
        <input class="step-input input-{{question['questionId']}}"  type="text" placeholder="{{question['tableTitle'][0]}}" (blur)="stepBlur(question['questionId'],i)" maxlength="20" value="{{item[0]}}" (focus)="inputFocus($event,i)"/>
        <div class="step-textarea">
          <component-textarea [id]="i" [type]="question.type" [questionId]="question['questionId']" [textareaValue]="item[1]" [isShowWordLimit]="true" [maxLen]="200" [placeholder]="question['tableTitle'][1]" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
        </div>
      </div>
    </div>
    <div id="add-question-{{question['questionId']}}" class="add-step" [ngClass]="{'disabled':disabledAdd}" (click)="addStep(question['questionId'],i)">
      添加步骤
    </div>
  </div>

<!--  表格题-->
<div class="question-answer-step question-{{question['questionId']}}" id="type-{{question.type}}" *ngIf="question.type === 6">
  <div class="answer-step-wrap" id="answer-step-wrap-{{i}}" *ngFor="let item of stepGroup;let i=index">
    <div class="step-title">
      <span class="step-circle"></span>
      <p>{{item[0]}}</p>
    </div>
    <div class="step-content">
      <div class="step-textarea">
        <component-textarea [id]="i" [type]="question.type" [questionId]="question['questionId']" [textareaValue]="item[1]" [isShowWordLimit]="true" [maxLen]="200" [placeholder]="question['tableTitle'][1]" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
      </div>
    </div>
  </div>
</div>

  <!--  类型为8的步骤题 与3的区别在于默认填充作答内容-->
  <div class="question-answer-step question-{{question['questionId']}}" id="type-{{question.type}}" *ngIf="question.type === 8">
    <div class="answer-step-wrap" id="answer-step-wrap-{{i}}" *ngFor="let item of stepGroup;let i=index">
      <div class="step-title">
        <span class="step-circle"></span>
        <p>{{question['tableTitle'][0]}}{{i+1}}</p>
        <div *ngIf="stepGroup.length > 1" class="minus-step" (click)="minusStep(i,question['questionId'])"></div>
      </div>
      <div class="step-content">
        <input class="step-input input-{{question['questionId']}}"  type="text" placeholder="{{question['tableTitle'][0]}}" (blur)="stepBlur(question['questionId'],i)" maxlength="20" value="{{item[0]}}" (focus)="inputFocus($event,i)"/>
        <div class="step-textarea">
          <component-textarea [id]="i" [type]="question.type" [questionId]="question['questionId']" [textareaValue]="item[1]" [isShowWordLimit]="true" [maxLen]="200" [placeholder]="question['tableTitle'][1]" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
        </div>
      </div>
    </div>
    <div id="add-question-{{question['questionId']}}" class="add-step" [ngClass]="{'disabled':disabledAdd}" (click)="addStep(question['questionId'],i)">
      <p>添加步骤</p>
    </div>
  </div>

<!-- 题干展示支持图片展示现在只有推动创新展示一张图片   -->
<div class="question-img-download" *ngIf="question.type === 7">
  <div class="question-img-box">
    <div class="img-item" *ngFor="let item of imgList;let i=index" (click)="showPreview(item.fileUrl,1)" >
      <img :src="{{item.fileUrl}}" alt="">
      <img src="{{assetsRoute}}/picture/camp/download_img.png" alt="">
    </div>
  </div>

  <component-textarea  [id]="questionNo" [type]="question.type" [questionId]="question['questionId']" [textareaValue]="question['answers']?question['answers']:''" [isShowWordLimit]="exerciseType!==3" [maxLen]="exerciseType === 3 ? 9999 : 200" [placeholder]="'请输入你的答案...'" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
</div>

<!--  实战作业不定项选择题-->
  <ul class="question-answer-checkbox question-{{question['questionId']}}" *ngIf="question.type === 4 && (isLastDay || isFirstDay)">
    <li [ngClass]="{'active':item['select']}" *ngFor="let item of question['options'];let i=index" (click)="checkboxSelected(i,question['questionId'])">
      <span>{{item.context.split(".")[0]}}.</span><span>{{item.context.split(".")[1]}}</span>
    </li>
  </ul>
<!--  智能作业不定项选择题-->
<ul class="question-answer-checkbox question-{{question['questionId']}}" *ngIf="question.type === 4 && !isLastDay && !isFirstDay">
    <!-- active:选中的选项或者不完全选对的情况下正确的选项 checkBoxData：选中选项的optionid拼接 multipleAnswers：正确答案选项的optionid拼接 -->
    <li [ngClass]="{'active':(item['select'] && showViewAnswerBtn)|| (!showViewAnswerBtn && item['select'] && item.correct && checkBoxData != multipleAnswers && multipleAnswers.indexOf(item.optionId) != -1) ,'right':item['select']&& item.correct && !showViewAnswerBtn && checkBoxData == multipleAnswers,'wrong':item['select']&& !item.correct && !showViewAnswerBtn && checkBoxData != multipleAnswers}" *ngFor="let item of question['options'];let i=index" (click)="checkboxSelected(i,question['questionId'])">
      <span>{{item.context.split(".")[0]}}.</span><span>{{item.context.split(".")[1]}}</span>
    </li>
  <button class="submitBtn" *ngIf="showViewAnswerBtn" [ngClass]="{'disable':disableAnswerBtn}" (click)="viewAnswer()">查看答案</button>
  <div *ngIf="isShowAnalysis"  class="question-answer-analysis">
    <p><span>答案解析</span><span>（点击选项可以重新选择答案）</span></p>
    <span [innerHtml]="analysis" ></span>
  </div>
</ul>
<!--  上传题-->
  <div class="question-answer-upload question-{{question['questionId']}}" *ngIf="question.type === 5">
    <div class="question-file-download" *ngIf="pdfList && pdfList.length > 0">
      <div class="file-item" *ngFor="let item of pdfList;let i=index" (click)="downloadPDF(item['url'])">
        {{item['name']}}
      </div>
    </div>

    <div class="question-upload-container" *ngIf="isLastDay && ((campId !=2 && !checkElse) || campId == 2)">
      <component-textarea  *ngIf="campId == 2" [id]="questionNo" [type]="5" [questionId]="question['questionId']" [textareaValue]="question['answers']?question['answers']:''" [isShowWordLimit]="exerciseType!==3" [maxLen]="exerciseType === 3 ? 9999 : 200" [placeholder]="'请输入你的答案...'" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
      <div class="actural-question-upload-list" *ngIf="campId == 2 || campId !== 2! && !checkElse">
        <ng-container  *ngIf="uploadList && uploadList.length > 0">
          <div class="upload-item" [ngClass]="{'fromPc':terminalType == 1}" [ngStyle]="{'background': item['fileType'] === 1 ? 'url('+ item['fileUrl'] +') no-repeat' : 'white','background-size':item['fileType'] === 1 ? 'cover':'unset' }" *ngFor="let item of uploadList;let i=index"  (click)="showPreview(item['fileUrl'],item['fileType'])">
            <div class="delete-file" (click)="deleteFile(i)"></div>
            <div class="item-file-name" *ngIf="item['fileType'] !== 1">
              <div *ngIf="!item.extend" class="file-icon"></div>
              <img *ngIf="item.extend" src="{{assetsRoute}}/picture/applicationTool/{{item.extend}}.png" class="tool-icon">
              <p class="file-name">{{item['fileName']}}</p>
            </div>
          </div>
        </ng-container>
        <p class="question-upload-tips" *ngIf="terminalType == 1 && uploadList.length > 0"><span>如需在手机端上传附件作为答案，请先清空已编辑表单</span></p>
        <div class="add-step" *ngIf="terminalType == 2 && uploadList.length<10" [ngClass]="{'disabled':uploadDisabled}" (click)="startUpload()">
          <img *ngIf="!uploadDisabled" src="{{assetsRoute}}/picture/camp/add.png" alt="">
          <img *ngIf="uploadDisabled" src="{{assetsRoute}}/picture/camp/add-disabled.png" alt="">
         <div style="text-align: center;">
          <b>上传文件</b>
          <p>（PDF或图片）</p>
         </div>
        </div>
      </div>

      <input style="position: absolute;opacity: 0;height: 0;width: 0;margin: 0;padding: 0" type="file" id="upload_input" (change)="uploadFile($event,question['questionId'])"  />
    </div>

  </div>
</div>

<component-tip *ngIf="isShowToast" [type]="'toast'" [theme]="toastTip? toastTip:'circle'" [desText]="destext" [cancelText]="''" [sureText]="''" ></component-tip>



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work-item/item.component.html